import Service from "./Service";
import {
  OrderStatus,
  DealStatus,
  AmendStatus,
  PolicyStatus,
  TourCustomerStatus,
  TourAmendOrderStatus,
  FlightPolicyState,
  FlightCNOrderState,
  InterFlightPolicyState,
  TrainOrderStatus,
  TrainAmendOrderStatus,
  HotelRefund,
  AirportInfoEntity,
  AirwayEntity,
  AirwayInfoEntity,
  AreaInfoEntity,
  BerthEntity,
  BerthInfoEntity,
  BusinessInfoEntity,
  CategoryInfoEntity,
  Categorys,
  CompanyType,
  CapitalType,
  CompanySize,
  ApplyArea,
  CardType,
  UserStatus,
  Sex,
  YesOrNo,
  VoyageType,
  RoleType,
  PaymentType,
  FlightType,
  ConsumerType,
  BillCycle,
  ServiceMode,
  CalcPriceMode,
  CalcBenchmark,
  RuntimeEnvironment,
  WorkStatus,
  DataRange,
  AuthorizeState,
  RoleCategory,
  EventType,
  InvoiceStatus,
  UnitPrice,
  TradeMode,
  FileType,
  MessageType,
  TravelStatus,
  BusinessType,
  SecurityType,
  CreateMode,
  ServiceType,
  ProblemType,
  ContactType,
  SetsType,
  TeamStatus,
  PriceStatus,
  PolicyType,
  TradeType,
  TradeStatus,
  AuditStatus,
  ApplyStatus,
  RefundStatus,
  ZoneType,
  TicketDelivery,
  TicketType,
  BackAirportType,
  ApplicableObject,
  ApplyPrice,
  ApplyWeek,
  LimitPassageType,
  FreightBasicsRule,
  ChildrewardRules,
  BabywardRules,
  CodingRule,
  PointsType,
  AirlineType,
  InformationsType,
  NotificationType,
  ExamineType,
  TrainSeatType,
  Cabin,
  LowestRule,
  TrainType,
  ApplicableCase,
  CollectFeesType,
  TravelReasonType,
  FlightRefundReason,
  BookingType,
  ApprovalRecordType,
  ReservationMode,
  ServiceTimeType,
  ScreeningRulesType,
  FlightTimeStatus,
  RuleType,
  ExpensesType,
  DelayType,
  PriceType,
  ActiveStatus,
  FlowMode,
  AccountType,
  CreditType,
  BillStatus,
  HotelRefundReason,
  InvoiceRole,
  InvoiceType,
  TakeType,
  AuthType,
  NotifyType,
  OverdueStatus,
  SaleRuleType,
  MemberType,
  NotifyContentType,
  NotifyScope,
  ExpressType,
  DutyCode,
  SignCode,
  ExtraCode_Wechat,
  OrderStatusCode,
  ProductExtraCode,
  GoodExtraCode,
  SupplyExtraCode,
  AccessCode,
  UnionStatus,
  CityInfoEntity,
  CityLevelEntity,
  ConfigInfo,
  ContinentInfoEntity,
  CountryInfoEntity,
  DistrictInfoEntity,
  ExtraInfoEntity,
  HotelGJCityEntity,
  MapInfoEntity,
  ProvinceInfoEntity,
  ScenicInfoEntity,
  StationInfoEntity,
  TourCityEntity,
  TownInfoEntity,
  TrainCityInfoEntity,
  ZoneInfoEntity,
  ZoneInfo,
} from "../model/Base";
import { PageList } from "@/model/system";
class baseService extends Service {
  getCountrys(id: string) {
    return this.get<CountryInfoEntity>("/CountryInfo/Countrys/${id}");
  }
  getCitys(countryID: string) {
    return this.get<CityInfoEntity>("/TourServers/GetCityInfo/${countryID}");
  }
  getTrainStation(data: any) {
    return this.post<any>("/TourServers/LoadCityInfo", data);
  }
  getdistinct(data: DistrictInfoEntity) {
    return this.post<DistrictInfoEntity>("/DistrictInfo/GetDist", data);
  }
  getZoneList(data: ZoneInfoEntity) {
    return this.post<PageList<ZoneInfoEntity>>("/ZoneInfo/List", data).then(function(json: any) {
      if (!json.isSucc || !json.result || !json.result.entities) {
        return json;
      }
      for (let i = 0; i < json.result.entities.length; i++) {
        let result = json.result.entities[i];
        let keywords = result.CityName + "," + result.CountryName + "," + result.ZoneName + "," + result.ZoneCode + "," + result.ZoneShortSpell + "," + result.ZoneSpell;
        result.keywords = keywords;
        result.label = result.ZoneName;
      }
      return json;
    });
  }
  getAirwayInfoList(data: AirwayInfoEntity) {
    return this.post<PageList<AirwayInfoEntity>>("/AirwayInfo/List", data);
  }
  gettripcomVersion() {
    let reg = /^app./g;
    let hostname = window.location.hostname;
    if (!reg.test(hostname) || hostname == "app.ecs.net") {
      hostname = "app.lchtrip.com";
    }
    return this.get("/static/${hostname.replace(/./g,'')}/version.json".replace("/api/base", ""));
  }
}
export default new baseService("base");
